import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

const createDefaultOptions = () => {
  return {
    center: new window.google.maps.LatLng(37.4419, -122.1419),
    zoom: 10,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    streetViewControl: false,
    fullscreenControl: false,
  };
};

/**
 * Create a map that shows up the entire US.
 */
const createDefaultMap = (domElement, defaultOptions) => {
  const map = new window.google.maps.Map(domElement, defaultOptions);

  const US = {
    NorthEast: {
      lat: 49.38,
      lng: -66.94,
    },
    SouthWest: {
      lat: 25.82,
      lng: -124.39,
    },
  };

  const usaBounds = new window.google.maps.LatLngBounds(
    new window.google.maps.LatLng(US.SouthWest.lat, US.SouthWest.lng),
    new window.google.maps.LatLng(US.NorthEast.lat, US.NorthEast.lng),
  );

  map.fitBounds(usaBounds);

  return map;
};

/**
 * @todo Use a proper third party react Map component.
 */
@observer
class Map extends Component {
  domRef = null;

  map = null;

  marker = null;

  constructor(props) {
    super(props);

    this.domRef = React.createRef();
  }

  componentDidMount() {
    if (!(window.google && window.google.maps)) {
      throw new Error("Google maps library not detected");
    }

    const { latLng, zoom } = this.props;
    const dom = this.domRef.current;

    if (latLng) {
      const options = { ...createDefaultOptions(), center: latLng, zoom };
      this.map = new window.google.maps.Map(dom, options);
    } else {
      this.map = createDefaultMap(dom, createDefaultOptions());
    }
  }

  componentDidUpdate() {
    const { latLng, zoom } = this.props;

    if (!latLng) {
      return;
    }

    this.updateMap(latLng, zoom);
  }

  onMarkerChange(event) {
    const { onMarkerPositionChange } = this.props;
    if (event.latLng) {
      onMarkerPositionChange({
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      });
    }
  }

  updateMap(latLng, zoom) {
    this.map.setCenter(latLng);
    this.map.setZoom(zoom);

    if (this.marker) {
      this.marker.setPosition(latLng);
    } else {
      this.marker = new window.google.maps.Marker({
        map: this.map,
        position: latLng,
        draggable: true,
      });

      // Register listener when marker changes position.
      window.google.maps.event.addListener(this.marker, "dragend", event => this.onMarkerChange(event));
    }
  }

  render() {
    const { width, heightAspectRation } = this.props;
    // 16:9 aspect ratio.
    const height = Math.floor(width * heightAspectRation);

    const domWidth = `${width}px`;
    const domHeight = `${height}px`;

    return <div ref={this.domRef} className="google-map-container" style={{ width: domWidth, height: domHeight }} />;
  }
}

Map.propTypes = {
  // must be a number so it can be used as px. Percentage won't work.
  width: PropTypes.number,
  heightAspectRation: PropTypes.number,
  // whatever is returned by a geocoder result geometry.location value.
  latLng: PropTypes.any,
  zoom: PropTypes.number,
  onMarkerPositionChange: PropTypes.func.isRequired,
};

Map.defaultProps = {
  width: 200,
  heightAspectRation: 9 / 16,
  zoom: 16,
};

export default Map;
